export default "__VITE_ASSET__CYBSTqKH__"